module.exports = __webpack_public_path__ + "img/Logo_Kopilote.1909603c.png";